import * as Sentry from '@sentry/react'
import { Button } from '@/components/ui/button'

function ErrorFallback() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center">
      <h1 className="mb-4 text-2xl font-bold">Something went wrong</h1>
      <p className="text-muted-foreground mb-4">We've been notified and are looking into it.</p>
      <Button onClick={() => window.location.reload()}>Refresh Page</Button>
    </div>
  )
}

export function ErrorBoundary({ children }: { children: React.ReactNode }) {
  return <Sentry.ErrorBoundary fallback={<ErrorFallback />}>{children}</Sentry.ErrorBoundary>
}
